import React from 'react';

/**
 * 発送元選択セル（広島/滋賀）。仕入先共有・仕入先共有編集の両方で利用。
 *
 * props:
 * - value: '広島' | '滋賀' | null
 * - onChange: (origin: '広島' | '滋賀' | null) => void
 * - disabled?: boolean
 */
export const ShipmentOriginCell = ({ value, onChange, disabled = false }) => {
  const currentOrigin = value || null;

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) onChange(currentOrigin === '広島' ? null : '広島');
        }}
        disabled={disabled}
        className={`px-2 py-1 text-xs rounded transition-colors ${
          currentOrigin === '広島'
            ? 'bg-blue-600 text-white'
            : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        広島
      </button>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          if (!disabled) onChange(currentOrigin === '滋賀' ? null : '滋賀');
        }}
        disabled={disabled}
        className={`px-2 py-1 text-xs rounded transition-colors ${
          currentOrigin === '滋賀'
            ? 'bg-blue-600 text-white'
            : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
        } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        滋賀
      </button>
    </div>
  );
};

export default ShipmentOriginCell;
